var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home-bet-creator" }, [
    _vm.game
      ? _c(
          "button",
          {
            staticClass: "bet-creator__action btn btn_blue",
            class: { "is-loading": _vm.isCreatingBet },
            attrs: {
              type: "button",
              disabled: _vm.isButtonDisabled || _vm.isCreatingBet,
            },
            on: { click: _vm.createBet },
          },
          [
            _c(
              "span",
              { staticClass: "btn__text" },
              [
                _vm.game.status === _vm.GameStatus.CREATED
                  ? [_vm._v("开始")]
                  : _vm.game.status === _vm.GameStatus.STARTED ||
                    _vm.game.status === _vm.GameStatus.ENDED
                  ? [_vm._v(" 开奖中... ")]
                  : _vm._e(),
                !_vm.isButtonDisabled && _vm.selectedInvItems.length > 0
                  ? _c("span", { staticStyle: { "margin-left": "5px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatCurrency(_vm.selectedInventoryAmountUsd)
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]
        )
      : _c(
          "button",
          {
            staticClass: "bet-creator__action btn btn_blue",
            attrs: { type: "button", disabled: "" },
          },
          [_c("span", { staticClass: "btn__text" }, [_vm._v("开始")])]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }